import React, { createContext, useContext, useState, useCallback } from "react";

const MapDataContext = createContext();

export function MapDataProvider(props) {
	const [activeMarkerId, setActiveMarkerId] = useState(null);
	const [markers, setMarkers] = useState(props.sortedMarkers);
	const [filterOptions, setFilterOptions] = useState(props.filterOptions);
	const [currentFilterOption, setCurrentFilterOption] = useState(props.currentFilter || 'all');

	function updateMarkerVisibility(filter) {
		console.log(filter, "updating markers");
		// const updatedMarkers = markers.map((marker) => {
		// 	if (marker.municipality == '') {
		// 		console.error(`${marker.title} (${marker.markerId}) has no municipality`);
		// 	}
		// 	marker.visible = (marker.municipality == filter || filter == 'all') ? true : false;
		// 	return marker;
		// })
		setActiveMarkerId(null);
		// setMarkers(updatedMarkers);
		setCurrentFilterOption(filter);
	}

	function handleMarkerClicked(markerId) {
		setActiveMarkerId(markerId);
	}

	return (
		<MapDataContext.Provider
			value={{
				activeMarkerId,
				setActiveMarkerId,
				markers,
				setMarkers,
				updateMarkerVisibility,
				filterOptions,
				setFilterOptions,
				currentFilterOption,
				setCurrentFilterOption,
				handleMarkerClicked,
			}}
		>
			{props.children}
		</MapDataContext.Provider>
	);
}


export default function useMapDataContext() {
	const context = useContext(MapDataContext);

	if (context === undefined) {
		throw new Error(
			"useMapDataContext must be used within a MapDataProvider",
		);
	}

	return context;
}
